export default __webpack_public_path__ + "static/media/Benefits5.cc48e142.bin";